module.exports = __webpack_public_path__ + "static/media/icon.ef645740.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon.png
// module id = 2007
// module chunks = 0